import React, { useState } from "react";
import "./Auth.css";
import Cookies from "js-cookie";

const Login = () => {

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleLoginResponse = (response) => {
    if (response.status === 200) {
      const { token, firstName, userId } = response.data;
      localStorage.setItem("token", token);
      localStorage.setItem("userId", userId);
      localStorage.setItem("firstName", firstName);
      alert("Login Successful!");
      window.location.href = "/";
    } else {
      alert("Invalid Credential Please Check Again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://backend.rubiajewels.com/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      response.data = data;
      handleLoginResponse(response);
    } catch (error) {
      console.error("Error during login:", error);
      alert("Something went wrong. Please try again!");
    }
  };

  

  // if (token) {
  //   alert("You are already logged in!");
  //   window.location.href = "/";
  //   return null;
  // }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1 className="auth-title">Login</h1>
        <form onSubmit={handleSubmit}>
          <label className="auth-label">Email</label>
          <input
            className="auth-input"
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
          <label className="auth-label">Password</label>
          <input
            className="auth-input"
            type="password"
            name="password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleChange}
            required
          />
          <button type="submit" className="auth-button">
            Sign In
          </button>
        </form>
        <p className="auth-footer">
          Don't have an account? <a href="/register">Register</a>
        </p>
      </div>
    </div>
  );
};

export default Login;
